import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { BsFillTelephoneXFill } from 'react-icons/bs'
import { BiDialpadAlt } from 'react-icons/bi'
import { useLocation, useNavigate } from 'react-router-dom'
import { placeCall, endCall } from '../../socket/services/call'
import routes from '../../routes/routes'
import { getAvatar } from '../../utils/avatar'

export function OutgoingCallPage() {
  const navigate = useNavigate()
  const { state } = useLocation()

  const [phoneNumber] = useState(state)

  const handleCallCancel = () => {
    endCall()
    navigate(routes.ContactList.path, { replace: true })
  }

  const handleModalDialerOnCall = () => {
    navigate(routes.DialerPage.path, { replace: true })
  }

  useEffect(() => {
    window.addEventListener('callAccepted', () =>
      navigate(routes.OngoingCallPage.path, { replace: true, state: {number: state, timer: 0} }),
    )

    placeCall(phoneNumber)
  }, [])

  return (
    <main className={styles.mainWrapper}>
      <div className={styles.information}>
        <p>Ligando</p>
        <div className={styles.avatar}>
          <img
            src={getAvatar(phoneNumber)}
            className={styles.avatarImage + ' ' + styles.ping}></img>
        </div>
        <div className={styles.userInfo}>
          <p className={styles.number}>{phoneNumber}</p>
        </div>
      </div>
      <hr />
      <div className={styles.buttons}>
        <div
          className={styles.dialNumber + ' ' + styles.actionIcon}
          onClick={handleModalDialerOnCall}>
          <div className={styles.number}>
            <BiDialpadAlt />
          </div>
        </div>
        <div
          className={styles.dialNumber + ' ' + styles.callButton}
          onClick={handleCallCancel}>
          <div className={styles.number}>
            <BsFillTelephoneXFill />
          </div>
        </div>
        <div className={styles.dialNumber + ' ' + styles.actionIcon}></div>
      </div>
    </main>
  )
}
